import * as tf from '@tensorflow/tfjs';
import * as solo from 'solo-emotions-engine';
import _ from "lodash";
import {extractEyesDirection, FaceLandmarkerWrapper} from "../facemesh";
import {getConfigItem} from "../../config";
import {loadMaskModel, detectFaceMask} from "../mask";

import {
    captureFrame,
    captureImage,
    captureBoxFromFrame,
    getBoxImgData,
} from "../../utils/capture-utils";

tf.setBackend('webgl');

let modelsDirExt = ""



export let soloInstance = null

export const FILTER_REASONS = {
    DETECTION_SCORE: 1,
    BOX_SIZE: 2,
    MASK: 3,
    LIGHT: 4,
    HAND: 5,
    HEAD_ANGLES: 6,
    HEAD_ANGLES_FALLBACK: 7,
}



const increaseBoxSize = (box, increaseBy = 50) => {
    return {
        x: box.x - increaseBy,
        y: box.y - increaseBy,
        width: box.width + 2 * increaseBy,
        height: box.height + 2 * increaseBy
    };
};

const decreaseBoxSize = (box, decreaseBy = 50) => {
    return {
        x: box.x + decreaseBy,
        y: box.y + decreaseBy,
        width: box.width - 2 * decreaseBy,
        height: box.height - 2 * decreaseBy
    };
}




export let landmarksWrapper = new FaceLandmarkerWrapper()


export const initEmotionDetection = async (modelsDir, config) => {
    await solo.nets.ssdMobilenetv1.loadFromUri(modelsDir)
    await solo.nets.tinyFaceDetector.loadFromUri(modelsDir)
    await solo.nets.faceExpressionNet.loadFromUri(modelsDir)
    await solo.nets.faceLandmark68Net.loadFromUri(modelsDir)

    await solo.loadFaceRecognitionModel(modelsDir)
    console.log("initializing landmarksWrapper")
    await landmarksWrapper.init()
    console.log("landmarksWrapper initialized")
    console.log("Models loaded")
    // if(config.MASK_MODEL_ACTIVE){
    await loadMaskModel(modelsDir)
    console.log("mask model loaded")
    //}

    modelsDirExt = modelsDir
    soloInstance = solo

    return true
}

export const filterBoxSize = (detection) => {
    let FILTER_BOX_SIZE = getConfigItem("FILTER_BOX_SIZE")
    if (FILTER_BOX_SIZE.active && (detection.alignedRect._box.width < FILTER_BOX_SIZE.minWidth || detection.alignedRect._box.height < FILTER_BOX_SIZE.minHeight)) {
        return true
    }
    return false
}

async function performLandmarksDetectionForBox(capturedFrame, detection) {
    const increasedBox = increaseBoxSize(detection.alignedRect._box, 130);
    const boxImage = captureBoxFromFrame(capturedFrame, increasedBox);
    const faceMeshResult = await landmarksWrapper.detect(boxImage, false, true);
    if (faceMeshResult.faces.boundingBoxes.length > 0) {
        return correctBoundingBoxCoordinates(faceMeshResult, increasedBox, capturedFrame, detection.alignedRect._box);
    }
    return faceMeshResult;
}

function correctBoundingBoxCoordinates(faceMeshResult, increasedBox, capturedFrame, originalBox) {
    // The corrected bounding box is relative to the original frame size.
    let originalFrameWidth = capturedFrame.width;
    let originalFrameHeight = capturedFrame.height;
    const detectedBoundingBox = faceMeshResult.faces.boundingBoxes[0];

    // Correct bounding box relative to the increased box in the original frame
    const correctedBoundingBox = {
        x: increasedBox.x + detectedBoundingBox.x,
        y: increasedBox.y + detectedBoundingBox.y,
        width: detectedBoundingBox.width,
        height: detectedBoundingBox.height
    };

   // console.log("correctedBoundingBox", {detectedBoundingBox, increasedBox, correctedBoundingBox})

    // Correct landmarks' positions based on the original frame coordinates
    const normalizedLandmarks = faceMeshResult.faces.faceLandmarks[0].map((landmark) => {
        // Calculate the absolute position of each landmark in the original frame.
        //const absoluteX = increasedBox.x + detectedBoundingBox.x + landmark.x * increasedBox.width;
        const absoluteX = increasedBox.x + (landmark.x * increasedBox.width);
      //  const absoluteY = increasedBox.y + detectedBoundingBox.y + landmark.y * increasedBox.height;
        const absoluteY = increasedBox.y + (landmark.y * increasedBox.height);

        // Normalize to the original frame dimensions.
        return {
            ...landmark,
            x: absoluteX / originalFrameWidth,
            y: absoluteY / originalFrameHeight,

        };
    });

    faceMeshResult.faces.boundingBoxes[0] = correctedBoundingBox
    faceMeshResult.faces.faceLandmarks[0] = normalizedLandmarks

    return faceMeshResult
}

const defaultOptions = new solo.SsdMobilenetv1Options({minConfidence: 0.3});







export const detectEmotions = async (input, modelsConfig) => {
    // console.log("detectEmotionsinput", input)

    let capturedFrame = input;
    let isImage = input instanceof HTMLImageElement
    //if input is video - capture the frame
    if (input instanceof HTMLVideoElement) {
        capturedFrame = captureFrame(input);
    }

    if (isImage) {
        capturedFrame = captureImage(input);
      //  console.log("detectEmotions isImage", capturedFrame)
    }

    const FILTER_BOX_SIZE_ACTIVE = getConfigItem("FILTER_BOX_SIZE_ACTIVE")
    const DETECTION_SCORE_FILTER_ACTIVE = getConfigItem("DETECTION_SCORE_FILTER_ACTIVE")
    const MASK_MODEL_ACTIVE = getConfigItem("MASK_MODEL_ACTIVE")
    const LIGHT_FILTER_ACTIVE = getConfigItem("LIGHT_FILTER_ACTIVE")
    const HAND_FILTER_ACTIVE = getConfigItem("HAND_FILTER_ACTIVE")
    const HEAD_ANGLE_EMOTION_FILTER_ACTIVE = getConfigItem("HEAD_ANGLE_EMOTION_FILTER_ACTIVE")
    //console.time("detectEmotions")
    let detectionsWithExpressions = await solo.detectAllFaces(capturedFrame, modelsConfig.emotionsModelOptions || defaultOptions).withFaceLandmarks().withFaceDescriptors().withFaceExpressions()
    //  console.timeEnd("detectEmotions")
    let lightIndex = null

    let faceMeshResult

    if (detectionsWithExpressions.length > 0) {


        faceMeshResult = await landmarksWrapper.detectHands(capturedFrame)
   //      console.log("hands faceMeshResult", faceMeshResult)
        // match face mesh with expression according to box position

        const detectionsToFilter = []
        const faceMeshToFilter = []
        const headPoseToFilter = []
        let fallbackLandmarks = false;
        for (let i = 0; i < detectionsWithExpressions.length; i++) {
            let detection = detectionsWithExpressions[i];

            let toFilter = false
            let filterReason = null

            if (DETECTION_SCORE_FILTER_ACTIVE && detection.detection.score < getConfigItem("DETECTION_SCORE_THRESHOLD")) {
                toFilter = true
                filterReason = FILTER_REASONS.DETECTION_SCORE
            }
            //filter detections with box size smaller than FILTER_BOX_SIZE
            let filerBoxSize = false
            if (FILTER_BOX_SIZE_ACTIVE) {
                filerBoxSize = filterBoxSize(detection);
                if (filerBoxSize) {
                 //   console.log("FILTER_BOX_SIZE filtering detection", i, detection)
                    toFilter = true
                    filterReason = FILTER_REASONS.BOX_SIZE
                }
            }

            if (MASK_MODEL_ACTIVE) {
                await detectFaceMask(capturedFrame, detection)
            //    console.log("detection.mask", detection.mask, getConfigItem("MASK_ON_CERTAINTY_THRESHOLD"))
                if (detection.mask > getConfigItem("MASK_ON_CERTAINTY_THRESHOLD")) {
                    toFilter = true
                    filterReason = FILTER_REASONS.MASK
                    // continue;
                }
            }

            if (LIGHT_FILTER_ACTIVE) {
                lightIndex = detectLightingLevels(detection.alignedRect._box);
                let LIGHT_FILTER_THRESHOLD = getConfigItem("LIGHT_FILTER_THRESHOLD")
                if (lightIndex < LIGHT_FILTER_THRESHOLD) {
                    toFilter = true
                    filterReason = FILTER_REASONS.LIGHT
                }
            }

            let bestMatch = {index: -1, iou: 0};
            let bestMatchingBox = null;

            detection.lightIndex = lightIndex;
            detection.headAnglesFallback = detection.angle;

         //   console.time("faceMeshResult");
            const localFaceMeshResult = await performLandmarksDetectionForBox(capturedFrame, detection);
            if(localFaceMeshResult.faces.boundingBoxes.length > 0){
                // merge local result to faceMeshResult
                if(faceMeshResult) {
                    faceMeshResult.faces.boundingBoxes.push(localFaceMeshResult.faces.boundingBoxes[0])
                    faceMeshResult.faces.faceLandmarks.push(localFaceMeshResult.faces.faceLandmarks[0])
                    faceMeshResult.faces.faceBlendshapes.push(localFaceMeshResult.faces.faceBlendshapes[0])
                    faceMeshResult.faces.headAngles.push(localFaceMeshResult.faces.headAngles[0])
                }

            }
           // console.timeEnd("faceMeshResult");

            if (!toFilter && localFaceMeshResult && (localFaceMeshResult.faces.boundingBoxes.length > 0)) { // Use your threshold
                bestMatch = {index: 0, iou: 1};
                // Process the best match
                bestMatchingBox = localFaceMeshResult.faces.boundingBoxes[bestMatch.index];

                //detect hands on the face
                if (HAND_FILTER_ACTIVE && faceMeshResult.hands && faceMeshResult.hands.absolutePositionLandmarks) {
                    const handPointsOnFace = nPointsInRect(faceMeshResult.hands.absolutePositionLandmarks, bestMatchingBox);
                    //console.log("handPointsOnFace", handPointsOnFace)
                    let HAND_POINTS_ON_FACE_THRESHOLD = getConfigItem("HAND_POINTS_ON_FACE_THRESHOLD")
                    if (handPointsOnFace >= HAND_POINTS_ON_FACE_THRESHOLD) {
                        toFilter = true
                        filterReason = FILTER_REASONS.HAND
                    }
                }

                let headAngles = localFaceMeshResult.faces.headAngles[bestMatch.index];
                if (HEAD_ANGLE_EMOTION_FILTER_ACTIVE) {
                    let validHeadAngles = headAngles && headFacingCameraEmotionFilter(headAngles)
                    if (!validHeadAngles) {
                        toFilter = true
                        filterReason = FILTER_REASONS.HEAD_ANGLES
                    }
                }

                // Update detection with best match details
                detection.faceLandmarks = localFaceMeshResult.faces.faceLandmarks[bestMatch.index];
                detection.faceBlendshapes = transformCategories(localFaceMeshResult.faces.faceBlendshapes[bestMatch.index].categories);
                detection.faceBlendshapes = addMeansToBlendshapes(detection.faceBlendshapes);
                detection.eyesDirection = extractEyesDirection(detection.faceBlendshapes);
                detection.middleEyes = getIrisesPoints(detection.faceLandmarks, bestMatchingBox)
                detection.headAngles = headAngles;
                detection.meshBoundingBox = bestMatchingBox;

            } else {
                console.log("No landmark results for detection", i, detection.alignedRect._box);
            }


            if (toFilter) {
                detectionsToFilter.push(i)
                detectionsWithExpressions[i].toFilter = true
                if (filterReason === FILTER_REASONS.MASK ) {
                    faceMeshToFilter.push(bestMatchingBox ? 0 : bestMatch.index)
                    headPoseToFilter.push(bestMatchingBox ? 0 : bestMatch.index)
                }
                detection.toFilter = true
                detection.filterReason = filterReason
                //continue
            }

            detectionsWithExpressions[i] = detection;
        }

        if (detectionsToFilter.length > 0) {

            detectionsWithExpressions = detectionsWithExpressions.map((value, index) => {
                if (!value.toFilter) {
                    return value
                } else {
                    value.expressions = {
                        angry: null,
                        disgusted: null,
                        fearful: null,
                        happy: null,
                        neutral: null,
                        sad: null,
                        surprised: null
                    }
                    return value
                }
            });
            //  console.log("after", detectionsWithExpressions)
        }
        if (faceMeshToFilter.length > 0) {
            // console.log("filtering faceMesh", faceMeshToFilter)
            faceMeshResult.faces.boundingBoxes = faceMeshResult.faces.boundingBoxes.filter((value, index) => !faceMeshToFilter.includes(index));
            faceMeshResult.faces.faceLandmarks = faceMeshResult.faces.faceLandmarks.filter((value, index) => !faceMeshToFilter.includes(index));
            faceMeshResult.faces.faceBlendshapes = faceMeshResult.faces.faceBlendshapes.filter((value, index) => !faceMeshToFilter.includes(index));
            //console.log("after faceMesh", faceMeshResult.faces.boundingBoxes)
        }

        if (modelsConfig && modelsConfig.showFaceLandmarks && modelsConfig.showFaceLandmarks.show) {
            landmarksWrapper.drawResults(faceMeshResult, modelsConfig.showFaceLandmarks.canvas, input, "#cc1d6c")
        }
    } else {
        if (modelsConfig && modelsConfig.showFaceLandmarks && modelsConfig.showFaceLandmarks.show) {
            landmarksWrapper.clearResults()
        }
    }


    if (modelsConfig.returnOriginalFacemesh) {
        return {detectionsWithExpressions, faceMeshResult};
    }
    return detectionsWithExpressions;
}

export const detectLightingLevels = (box) => {
    const data = getBoxImgData(box).data;

    let totalLuminance = 0;
    let pixelCount = 0;

    for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        // Calculate luminance using the Rec. 709 formula
        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        totalLuminance += luminance;
        pixelCount++;
    }

    // Average luminance
    const averageLuminance = totalLuminance / pixelCount;

    // Normalize the light index to a scale of 0 to 100
    const lightIndex = (averageLuminance / 255) * 100;

    return lightIndex;
}

const calculateAverageLuminance = (data) => {
    let totalLuminance = 0;
    let pixelCount = 0;

    for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];

        // Calculate luminance using the Rec. 709 formula
        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        totalLuminance += luminance;
        pixelCount++;
    }

    return totalLuminance / pixelCount;
};

const calculateAverageLuminanceExcludingFace = (data, width, height, faceBox) => {
    let totalLuminance = 0;
    let pixelCount = 0;

    const faceXStart = faceBox.x;
    const faceXEnd = faceBox.x + faceBox.width;
    const faceYStart = faceBox.y;
    const faceYEnd = faceBox.y + faceBox.height;

    for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
            const index = (y * width + x) * 4;

            // Skip pixels within the face area
            if (x >= faceXStart && x < faceXEnd && y >= faceYStart && y < faceYEnd) {
                continue;
            }

            const r = data[index];
            const g = data[index + 1];
            const b = data[index + 2];

            // Calculate luminance using the Rec. 709 formula
            const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
            totalLuminance += luminance;
            pixelCount++;
        }
    }

    // Return average luminance, or 0 if no valid pixels were found
    return pixelCount > 0 ? totalLuminance / pixelCount : 0;
};


const normalizeDifferenceToScale = (difference) => {
    const maxLuminanceDifference = 255; // Max difference in luminance
    return (difference / maxLuminanceDifference) * 100;
};

export const detectLightDifferenceLeftRight = (box) => {
    const {width, height, x, y} = box;
    const halfWidth = Math.floor(width / 2);

    // Round values to the nearest integer
    const leftSideData = getBoxImgData({
        x: x,
        y: y,
        width: Math.round(halfWidth),
        height: Math.round(height)
    }).data;

    const rightSideData = getBoxImgData({
        x: Math.round(x + halfWidth),
        y: y,
        width: Math.round(width - halfWidth),
        height: Math.round(height)
    }).data;

    const leftLuminance = calculateAverageLuminance(leftSideData);
    const rightLuminance = calculateAverageLuminance(rightSideData);

// Calculate difference as a percentage
    let ratio;
    if (rightLuminance > 0) {
        ratio = leftLuminance / rightLuminance;
    } else {
        ratio = 1; // Handle edge case where backgroundLuminance is 0 to avoid division by zero
    }

    // Normalize the ratio to a 0-100 scale
    const difference = ratioToNegativePositiveScale(ratio);
    return difference;
};

const convertLightIndexToLUX = (lightIndex) => {
    const slope = 1.64;
    const intercept = -6.62;
    const lux = (slope * lightIndex) + intercept;
    return lux;
}

function convertLightIndexToLUX2(lightingIndex) {
    // Coefficients from the quadratic regression
    const a = 0.0565;  // Coefficient for the squared term
    const b = 1.2412;  // Coefficient for the linear term
    const c = 4.6041;  // Constant term
    // Calculate Lux using the quadratic formula
    const lux = (a * Math.pow(lightingIndex, 2)) + (b * lightingIndex) + c;
    return lux;
}

export const detectLightDifferenceTopBottom = (box) => {
    const {x, y, width, height} = box;
    const halfHeight = Math.floor(height / 2);

    // Round values to the nearest integer
    const topSideData = getBoxImgData({
        x: Math.round(x),
        y: Math.round(y),
        width: Math.round(width),
        height: Math.round(halfHeight)
    }).data;

    const bottomSideData = getBoxImgData({
        x: Math.round(x),
        y: Math.round(y + halfHeight),
        width: Math.round(width),
        height: Math.round(height - halfHeight)
    }).data;

    const topLuminance = calculateAverageLuminance(topSideData);
    const bottomLuminance = calculateAverageLuminance(bottomSideData);

    let ratio;
    if (bottomLuminance > 0) {
        ratio = topLuminance / bottomLuminance;
    } else {
        ratio = 1; // Handle edge case where backgroundLuminance is 0 to avoid division by zero
    }

    // Normalize the ratio to a 0-100 scale
    const difference = ratioToNegativePositiveScale(ratio);
    return difference;
};

export const detectLightDifferenceFaceBackground = (faceBox, backgroundBox) => {
    const ctx = offScreenCanvas.getContext('2d');

    // Get image data for the entire background (including the face area)
    const backgroundData = ctx.getImageData(backgroundBox.x, backgroundBox.y, backgroundBox.width, backgroundBox.height).data;

    // Get face data
    const faceData = ctx.getImageData(faceBox.x, faceBox.y, faceBox.width, faceBox.height).data;

    // Calculate the luminance excluding the face area
    const backgroundLuminance = calculateAverageLuminanceExcludingFace(backgroundData, backgroundBox.width, backgroundBox.height, faceBox);

    // Calculate the luminance of the face for comparison
    const faceLuminance = calculateAverageLuminance(faceData);

    // Calculate difference as a percentage
    let ratio;
    if (backgroundLuminance > 0) {
        ratio = faceLuminance / backgroundLuminance;
    } else {
        ratio = 1; // Handle edge case where backgroundLuminance is 0 to avoid division by zero
    }

    // Normalize the ratio to a 0-100 scale
    const difference = ratioToNegativePositiveScale(ratio);
    return difference;
};
const ratioToNegativePositiveScale = (ratio) => {
    const minRatio = 0.0;  // Example: 0% means face is darker than the background
    const maxRatio = 2.0;  // Example: 200% means face is brighter than the background

    // Normalize the ratio to a scale of -100 to 100
    if (ratio < minRatio) {
        return -100;
    } else if (ratio > maxRatio) {
        return 100;
    } else {
        return ((ratio - minRatio) / (maxRatio - minRatio)) * 200 - 100;
    }
};
const ratioToScale = (ratio) => {
    const minRatio = 0.0;  // Example: 0% means face is darker than the background - 1 means the same
    const maxRatio = 2.0;  // Example: 200% means face is brighter than the background

    // Normalize the ratio to a scale of 0 to 100
    if (ratio < minRatio) {
        return 0;
    } else if (ratio > maxRatio) {
        return 100;
    } else {
        return ((ratio - minRatio) / (maxRatio - minRatio)) * 100;
    }
};

function addMeansToBlendshapes(blendshapes) {
    const means = {};
    const specialMappings = {
        'brow': 'brows',
        'eye': 'eyes',
        'cheek': 'cheeks',
    };

    for (const key in blendshapes) {
        if (key.endsWith('Left')) {
            const baseKey = key.slice(0, -4); // Remove 'Left' to find the base key
            const rightKey = baseKey + 'Right';

            if (blendshapes[rightKey]) {
                const meanScore = (blendshapes[key] + blendshapes[rightKey]) / 2;

                // Determine the appropriate key for the mean
                let meanKey;
                for (const [prefix, newPrefix] of Object.entries(specialMappings)) {
                    if (baseKey.startsWith(prefix)) {
                        meanKey = baseKey.replace(prefix, newPrefix);
                        break;
                    }
                }
                meanKey = meanKey || baseKey; // Use the baseKey + 'Mean' if no special mapping is found

                means[meanKey] = meanScore;
            }
        }
    }

    let eyesLookLeft = _.mean([blendshapes.eyeLookInRight, blendshapes.eyeLookOutLeft]);
    let eyesLookRight = _.mean([blendshapes.eyeLookInLeft, blendshapes.eyeLookOutRight]);

    return {...blendshapes, ...means, eyesLookLeft, eyesLookRight};
}

function nPointsInRect(points, rect) {
    let count = 0;

    for (let point of points) {
        if (point.x >= rect.x &&
            point.x <= rect.x + rect.width &&
            point.y >= rect.y &&
            point.y <= rect.y + rect.height) {
            count++;
        }
    }

    return count;
}

export function getIrisesPoints(landmarks, box) {
    // Define the landmark indices for the left and right iris
    const leftIrisIndices = [473];
    // For the right eye iris
    const rightIrisIndices = [468];


    // Initialize variables to calculate the average
    let leftIrisSum = {x: 0, y: 0};
    let rightIrisSum = {x: 0, y: 0};

    // Calculate the average for the left iris
    leftIrisIndices.forEach(index => {
        leftIrisSum.x += landmarks[index].x;
        leftIrisSum.y += landmarks[index].y;
    });

    const leftIrisCenter = {
        x: leftIrisSum.x / leftIrisIndices.length,
        y: leftIrisSum.y / leftIrisIndices.length
    };

    // Calculate the average for the right iris
    rightIrisIndices.forEach(index => {
        rightIrisSum.x += landmarks[index].x;
        rightIrisSum.y += landmarks[index].y;
    });

    const rightIrisCenter = {
        x: rightIrisSum.x / rightIrisIndices.length,
        y: rightIrisSum.y / rightIrisIndices.length
    };

    const leftIrisCenterPixel = {
        x: leftIrisCenter.x * box.width,
        y: leftIrisCenter.y * box.height
    }

    const rightIrisCenterPixel = {
        x: rightIrisCenter.x * box.width,
        y: rightIrisCenter.y * box.height
    }

    return {leftIrisCenter, rightIrisCenter, leftIrisCenterPixel, rightIrisCenterPixel};
}

function transformCategories(categoriesArray) {
    const categoriesObject = {};
    categoriesArray.forEach(category => {
        categoriesObject[category.categoryName] = category.score
    });
    return categoriesObject;
}

function calculateIoU(box1, box2) {
    const xA = Math.max(box1.x, box2.x);
    const yA = Math.max(box1.y, box2.y);
    const xB = Math.min(box1.x + box1.width, box2.x + box2.width);
    const yB = Math.min(box1.y + box1.height, box2.y + box2.height);

    const intersectionArea = Math.max(0, xB - xA) * Math.max(0, yB - yA);
    const box1Area = box1.width * box1.height;
    const box2Area = box2.width * box2.height;
    const unionArea = box1Area + box2Area - intersectionArea;

    return intersectionArea / unionArea;
}

function isBoundingBoxMatch(box1, box2, threshold = 0.4) {
    const iou = calculateIoU(box1, box2);
    return iou > threshold;
}

export const uploadImage = async () => {
    const imgFile = document.getElementById('imageUpload').files[0]
    const img = await solo.bufferToImage(imgFile)
    let imageElement = document.getElementById('myImage');
    imageElement.src = img.src

    // let correctedImage = await correctImageOrientation(img)
    // imageElement.src = correctedImage.src

}
// Initialize the faceIdMap to store face IDs and their descriptors
export const faceIdMap = new Map();

// Function to find a matching face ID based on face descriptors

export function filterFaceIdMap(facesToKeep) {
    for (const [faceID, storedDescriptor] of faceIdMap.entries()) {
        if (!facesToKeep.includes(faceID)) {
            faceIdMap.delete(faceID);
        }
    }
}

export const clearFaceIdMap = () => {
    faceIdMap.clear()
    currentFaceID = 0;
}

export function findMatchingFaceIDLocationBased(box, threshold) {
    //   console.log("findMatchingFaceIDLocationBased", box)
    // Iterate through the faceIdMap to find a matching face ID
    let matchedFace = null;
    let closestDistance = Infinity;
    for (const [faceID, storedBox] of faceIdMap.entries()) {
        // Calculate the similarity between the current descriptor and the stored descriptor
        const distance = Math.sqrt(
            (box.x - storedBox.x) ** 2 + (box.y - storedBox.y) ** 2
        );

        let minDistance = threshold || 50

        if (distance <= minDistance && distance < closestDistance) {
            matchedFace = faceID;
            closestDistance = distance;
        }

        if (!matchedFace && distance > minDistance) {
            console.log("distance", distance)
        }
    }

    return matchedFace;
}

let currentFaceID = 0;

// Function to generate a random face ID
export function generateFaceID() {
    currentFaceID += 1;
    return currentFaceID // You can adjust the length of the ID if needed
}

export const options = new solo.SsdMobilenetv1Options({minConfidence: 0.3});

export const getDefaultOptions = () => {
    return options
}

export function headFacingCameraEmotionFilter(detection) {
    const YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = getConfigItem("YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD");
    const YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = getConfigItem("YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD");
    const PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = getConfigItem("PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD");
    const PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = getConfigItem("PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD");
    const ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD = getConfigItem("ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD");
    const ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD = getConfigItem("ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD");

    let headNotFacingCamera = detection.yaw > YAW_ANGLE_MAX_EMOTION_FILTER_THRESHOLD || detection.yaw < YAW_ANGLE_MIN_EMOTION_FILTER_THRESHOLD
        || detection.pitch > PITCH_ANGLE_MAX_EMOTION_FILTER_THRESHOLD || detection.pitch < PITCH_ANGLE_MIN_EMOTION_FILTER_THRESHOLD
        || detection.roll > ROLL_ANGLE_MAX_EMOTION_FILTER_THRESHOLD || detection.roll < ROLL_ANGLE_MIN_EMOTION_FILTER_THRESHOLD;

    if (headNotFacingCamera) {
        return false
    }
    return true
}
